import axios from "axios";

import { logout } from "../app/slices/authSlice";

let store;

export const injectStore = (_store) => {
  store = _store;
};

//* ADMIN
export const serverApi = axios.create({
  baseURL: `${process.env.REACT_APP_SERVER_URL}/`,
  timeout: 300000,
});

serverApi.interceptors.response.use(
  (response) => {
    let { status } = response;
    if (status === 401) {
      store.dispatch(logout());
      return response;
    } else {
      return response;
    }
  },
  (error) => {
    if (error.response === undefined) {
      // store.dispatch(signOut());
    }
    // return Promise.reject(error);
    console.log(`Server unreachable`, error);
    throw new Error(`Server unreachable ${error?.message}`);
  }
);
